module.exports = __webpack_public_path__ + "static/img/ewmImg.201077a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/ewmImg.jpg
// module id = NU+8
// module chunks = 7